export const sortIconByName = (icon) => {
  icon.sort((a, b) =>
    a.cName.localeCompare(b.cName, "zh-Hans-CN", { sensitivity: "accent" })
  );
  return icon;
};

export const validateWhiteSvg = (code) => {
  if (!code.length) {
    return false;
  }
  const regex = /((#[f]{6})|(#[f]{3}))/gi;
  const regexAll = /(#[abcdef0-9]{6})/gi;
  const allMatch = code.match(regexAll);
  const match = code.match(regex);
  if (match && allMatch && match.length === allMatch.length) {
    return true;
  }
  return false;
};

export const sortIconById = (icons) => {
  icons.sort((a, b) => a.product_map_id - b.product_map_id);
  return icons;
};
